import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Application } from '../model/Application';
import { QueryOptionDto } from '../model/QueryOptionDto';
import { Transfer } from '../model/transfer/Transfer';
import { RenewalRequest } from '../model/renewal/RenewalRequest';
import { CallHttpService } from './call-http.service';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  constructor(private callHttpService: CallHttpService) {}

  saveApplication(application: Application) {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/save`,
      application
    );
  }

  getApplications(options: QueryOptionDto): Observable<any> {
    const body = options.options;
    return this.callHttpService.post(
      `${environment.academyApi.applications}/getApplications`,
      { options: body }
    );
  }

  updateApplication(application: Application) {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/updateApplication`,
      application
    );
  }

  getApplicationById(id: string) {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/getApplicationById/`,
      { id: id }
    );
  }

  getTransfers(options: QueryOptionDto): Observable<any> {
    const body = options.options;
    return this.callHttpService.post(
      `${environment.academyApi.applications}/getTransfers`,
      { options: body }
    );
  }

  updateTransfer(transfer: Transfer): Observable<any> {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/updateTransfer`,
      transfer
    );
  }

  getMassiveApplication(options: QueryOptionDto): Observable<any> {
    const body = options.options;
    return this.callHttpService.post(
      `${environment.academyApi.applications}/getMassiveApplication`,
      { options: body }
    );
  }

  getApplicationWithMemberDetails(id: string): Observable<any> {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/getApplicationById/`,
      { id: id }
    );
  }

  // Métodos para renovaciones
  getRenewalsByClubId(clubId: string): Observable<any> {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/getRenewalsByClubId`,
      { clubId: clubId }
    );
  }

  createRenewalApplications(request: RenewalRequest): Observable<any> {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/createRenewalApplications`,
      request
    );
  }

  updateRenewal(renewal: Application): Observable<any> {
    return this.callHttpService.post(
      `${environment.academyApi.applications}/updateRenewal`,
      renewal
    );
  }

  getRenewals(options: QueryOptionDto): Observable<any> {
    const body = options.options;
    return this.callHttpService.post(
      `${environment.academyApi.applications}/getRenewals`,
      { options: body }
    );
  }
}
